import { request } from './core.api';

export interface DashboardDto {
  totalProperties: number;
  totalActiveTenants: number;
  propertyStatuses: {
    rented: number;
    vacant: number;
    underRenovation: number;
    forSale: number;
  };
  buildingOccupancy?: Array<{
    propertyId: string;
    displayName: string;
    occupiedUnits: number;
    totalUnits: number;
  }>;
  upcomingReminders: Array<{
    id: string;
    title: string;
    dueDate: string;
    propertyId?: string;
    propertyAddress?: string;
  }>;
  recentEvents: Array<{
    id: string;
    title: string;
    titleKey?: string;
    subjectName: string;
    date: string;
    eventType: string;
  }>;
}

export const dashboardApi = {
  get: () => request<DashboardDto>('/dashboard'),
};
